import React, {useCallback, useEffect, useState} from "react";
import style from "./SideBar.module.css"
import History from "./History";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import {useParams, useSearchParams} from "react-router-dom";
import ZoomCallScreen from "./ZoomCallScreen";
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import {Button, Modal, ModalBody, ModalFooter, OverlayTrigger, Tooltip} from "react-bootstrap";
import VideoRecorder from "./VideoRecorder";
import LiveKitCallScreen from "./LiveKit/LiveKitCallScreen";
import useWebSocket from "react-use-websocket";
import {useTranslation} from "react-i18next";
import {wsBaseUrl} from "../../api/ApiUtils";

export default function SideBar(props) {
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'sideBar'});
    const [playerName, setPlayerName] = useState("")
    const [onCall, setOnCall] = useState(false)
    const [queryParams] = useSearchParams()
    const [isHorizontal, setHorizontal] = useState(true)
    const [showVideoChangedWarn, setShowVideoChangedWarn] = useState(false)

    const params = useParams()

    const {
        lastJsonMessage,
    } = useWebSocket( wsBaseUrl + `ws/game/${params.id}/stream`, {
        shouldReconnect: () => true,
        share: true
    });

    useEffect(() => {
        if (lastJsonMessage?.message?.type === "video_change") {
            stopTheCall()
            props.updateGameState()
            if (onCall) {
                setShowVideoChangedWarn(true)
            }

        }
    }, [lastJsonMessage])


    function resolveUserName() {
        if (props.gameState?.role === "mentor") {
            setPlayerName("Mentor")
        } else {
            setPlayerName(props.selectedPlayer?.name)
        }
        startTheCall()
    }

    function startTheCall() {
        setOnCall(true)
        props.setOnVideoCall(true)
    }

    function stopTheCall() {
        setOnCall(false)
        props.setOnVideoCall(false)
    }

    const stopTheCallCallback = useCallback(stopTheCall, [onCall])

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    useEffectOnce(() => {
        if (props.gameState?.role === "mentor") {
            setPlayerName("Mentor")
        }

        if (queryParams.get("autovideo") === "on") {
            resolveUserName()
        }
    }, [])

    useEffect(() => {
        if (props.gameState.role === "mentor") {
            setPlayerName("Mentor")
        } else if (props.selectedPlayer) {
            setPlayerName(props.selectedPlayer.name)
        }
    })


    return (
        <>
            <div className={style.videoHorizontal}>
                {
                    !onCall && (props.gameState.video_allowed !== false) &&
                        <div className={style.flexCentered}>
                            <OverlayTrigger
                                placement="right"
                                delay={{show: 400, hide: 50}}
                                overlay={renderTooltip(t('call'))}
                            >
                                <div className={style.callControl}
                                     onClick={resolveUserName}>
                                    <VideoCameraFrontIcon
                                        style={{color: "white", font: "large", scale: "1.5"}}></VideoCameraFrontIcon>
                                </div>
                            </OverlayTrigger>
                        </div>

                }
            </div>
                {
                    playerName
                    && (props.gameState.video_allowed !== false)
                    && !props.gameState.is_trial_game
                    && <VideoRecorder gameId={props.gameState.id} name={playerName}/>}



            {onCall && props.gameState.video_provider !== 'livekit' &&
                <ZoomCallScreen
                    gameState={props.gameState}
                    userName={playerName}
                    onStop={stopTheCall}
                    isHorizontal={isHorizontal}
                    setHorizontal={setHorizontal}/>
            }

            {onCall && props.gameState.video_provider === 'livekit' &&
                <LiveKitCallScreen
                    game_id={props.gameState.id}
                    user_name={props.gameState.role === "mentor" ? "mentor" : props.selectedPlayer.name}
                    user_id={props.gameState.role === "mentor" ? "mentor" : props.selectedPlayer.id}
                    onStop={stopTheCallCallback}
                    isHorizontal={isHorizontal}
                    setHorizontal={setHorizontal}
                    isMentor={props.gameState.role === "mentor"}
                />
            }

            {props.selectedPlayer && <History gameState={props.gameState}
                                              updateGameState={props.updateGameState}
                                              cards={props.cards}
                                              role={props.gameState.role}
                                              selectedPlayer={props.selectedPlayer}
            />}
            <Modal
                show={showVideoChangedWarn}
                size="lg"
                onHide={() => setShowVideoChangedWarn(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <ModalBody>
                    <div style={{display: "flex", flexDirection: "column", alignItems:"center", fontWeight:"bold"}}>
                    <p>{t('videoTypeChanged')}</p>
                    <p>{t('currentCallEnded')}</p>
                    <p>{t('joinTheCallAgain')}</p>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" active={true} onClick={() => setShowVideoChangedWarn(false)}>Ok</Button>
                </ModalFooter>

            </Modal>
        </>


    )
}